import { Launch } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useModuleDrawerContext } from '../../../../contexts/ModuleDrawerContext';
import { drawerModulePaths } from './ModuleDrawer';
import { moduleDrawerStyles } from './moduleDrawerStyles';

const ModuleDrawerHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { moduleDrawerState, setModuleDrawerState } = useModuleDrawerContext();
  const navigate = useNavigate();

  const handleClose = () => setModuleDrawerState(null);

  const openNewPage = () => {
    if (!moduleDrawerState) return;
    const base = drawerModulePaths[moduleDrawerState.module];
    if (!base) return;
    setModuleDrawerState(null);
    navigate(`/${base}/${moduleDrawerState.uuid}`);
  };

  return (
    <Box sx={moduleDrawerStyles.header}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6" fontWeight={600} noWrap title={moduleDrawerState?.module}>
          {children}
        </Typography>
      </Box>
      <Box>
        <Tooltip title="Open full page">
          <IconButton onClick={openNewPage} aria-label="open full page">
            <Launch />
          </IconButton>
        </Tooltip>
        <IconButton onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ModuleDrawerHeader;
